import type { BeforeRequestHook } from 'ky';
import isNative from '../../../native/isNative';
import { addProjectHeader, extractProjectDetailsFromRoute } from '../../../projects';
import { isServer } from '../../utils';
import type { HookGetterArgs } from '../types';

export const getProjectHeaders = ({
  fetchArgs: { data, url },
  options,
}: HookGetterArgs): BeforeRequestHook => {
  const projectHeadersHook: BeforeRequestHook = async (request) => {
    if (options.meta?.disableProjectHeader) {
      return;
    }

    if (isServer() && url.startsWith('/')) {
      const { headers: nextHeaders } = await import('next/headers');
      const header = await nextHeaders();
      const { projectId } = extractProjectDetailsFromRoute(header.get('pathname') ?? '');
      addProjectHeader(request.headers, String(projectId));
    }

    if (!isServer() && !isNative()) {
      const { projectId: extractedProjectId } = extractProjectDetailsFromRoute(
        window.location.pathname,
      );

      const projectId =
        data && 'projectId' in data && data.projectId ? Number(data.projectId) : extractedProjectId;

      addProjectHeader(request.headers, String(projectId)); // converting projectId to string as we have to set it in headers
    }
  };
  return projectHeadersHook;
};
